<template>
  <div v-if="loading">
    <Loader />
  </div>
  <div class="card" v-if="!loading">
    <div class="card-header">
      <h3 class="card-title" style="font-size: 20px; font-weight: bold">
        อนุมัติรับสินค้าเข้าคลัง : PU2-4
      </h3>
    </div>
    <div class="card-title row ms-6 me-5 mt-6">
      <div class="col-sm-3 mb-3">
        <input
          v-model="searchInput"
          placeholder="ค้นหา"
          type="text"
          class="form-control"
        />
      </div>
      <div class="col-sm-1 text-end">
        <button
          @click="search"
          type="button"
          class="btn btn-sm btn-light-primary"
          style="font-size: 14px; font-weight: bold"
        >
          ค้นหา
        </button>
      </div>
      <!-- <div class="col-sm-3 text-end">
        <button
          @click="print9()"
          type="button"
          class="btn btn-sm btn-danger me-2"
          style="font-size: 14px; font-weight: bold"
        >
          พิมพ์ใบ ขย. 9
        </button>
      </div>
      <div class="col-sm-3 text-end">
        <button
          @click="exportExcel()"
          type="button"
          class="btn btn-sm btn-success me-2"
          style="font-size: 14px; font-weight: bold"
        >
          พิมพ์ใบ ขย. 9 Excel
        </button>
      </div>
      <div class="col-sm-2 text-end">
        <button
          @click="goToExportExcel()"
          type="button"
          class="btn btn-sm btn-primary me-2"
          style="font-size: 14px; font-weight: bold"
          title="ใบรับสินค้าทั้งหมด"
        >
          ใบรับสินค้า Excel
        </button>
      </div> -->
    </div>
    <div class="card-body" style="padding-top: 3px">
      <div class="table-responsive">
        <table
          class="table table-hover table-rounded table-striped border gy-7 gs-7"
        >
          <thead>
            <tr
              style="width: 100%"
              class="fw-bold fs-5 text-gray-800 border-bottom-2 border-gray-200 mw-200px"
            >
              <th class="text-center">เลขที่เอกสาร</th>
              <th class="text-center">รหัสผู้ขาย</th>
              <th class="text-center">ชื่อผู้ขาย</th>
              <th class="text-center">วันที่รับสินค้า</th>
              <th class="text-center">มูลค่าสินค้ารับเข้า</th>
              <th class="text-center">Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="dataItemsShow.length < 1">
              <td class="text-center" colspan="9">ไม่มีข้อมูล</td>
            </tr>
            <tr v-for="(item, index) in dataItemsShow" :key="index">
              <td>{{ item.receive_no ? item.receive_no : "" }}</td>
              <td>{{ item.vendor_code ? item.vendor_code : "" }}</td>
              <td>{{ item.vendor_name ? item.vendor_name : "" }}</td>
              <td>
                {{
                  item.receive_date
                    ? formatDate(item.receive_date.substring(0, 10))
                    : ""
                }}
              </td>
              <td class="text-end">{{ formatPrice(item.final_price) }}</td>

              <td class="text-center">
                <a
                  v-if="item.is_cancel === '0' && item.status === '3'"
                  style="color: #3ca76c; cursor: default; font-weight: 500"
                  >อนุมัติ</a
                >

                <a
                  v-if="item.is_cancel === '1'"
                  style="color: FireBrick; cursor: default; font-weight: 500"
                  >ยกเลิกแล้ว</a
                >

                <a
                  v-if="item.is_cancel === '2' && item.status === '3'"
                  style="color: grey; cursor: default; font-weight: 500"
                  >Complete</a
                >
              </td>

              <td>
                <div class="d-flex">
                  <!-- ปุ่มพิมพ์ -->
                  <div @mousedown="hoverExportBtn()" class="me-2">
                    <button
                      type="button"
                      class="btn btn-link btn-color-muted btn-active-color-success m-0 p-0"
                      @click="goToExport(item, index)"
                    >
                      <div
                        :class="
                          !loadingExport
                            ? ''
                            : index == indexExport
                            ? 'spinner-grow spinner-grow-sm text-light'
                            : ''
                        "
                        role="status"
                      >
                        <i class="bi bi-printer-fill"> </i>
                      </div>
                    </button>
                  </div>

                  <!-- ปุ่มพิมพ์ใบ ขย. 9 Excel -->
                  <div class="me-2">
                    <a-tooltip>
                      <template #title>พิมพ์ใบ ขย. 9 Excel</template>
                      <button
                        type="button"
                        class="btn btn-link btn-color-muted btn-active-color-success m-0 p-0"
                        @click="exportSingleExcel(item, index)"
                        title="พิมพ์ใบ ขย. 9 Excel"
                      >
                        <i class="bi bi-file-earmark-excel text-success"></i>
                      </button>
                    </a-tooltip>
                  </div>

                  <!-- ปุ่มใบรับสินค้า Excel -->
                  <div class="me-2">
                    <a-tooltip>
                      <template #title>ใบรับสินค้าทั้งหมด Excel</template>
                      <button
                        type="button"
                        class="btn btn-link btn-color-muted btn-active-color-primary m-0 p-0"
                        @click="exportReceiveExcel(item, index)"
                        title="ใบรับสินค้าทั้งหมด Excel"
                      >
                        <i class="bi bi-file-earmark-excel text-success"></i>
                      </button>
                    </a-tooltip>
                  </div>

                  <!-- ปุ่มอนุมัติ -->
                  <div
                    class="me-2"
                    v-if="item.status === '3' && item.is_cancel === '0'"
                  >
                    <button
                      class="btn btn-link btn-color-muted btn-active-color-success m-0 p-0"
                      @click="role === 'STAFF' ? '' : handleApprove(item, '1')"
                    >
                      <i class="bi bi-save"></i>
                    </button>
                  </div>

                  <!-- ปุ่มยกเลิก -->
                  <div v-if="item.status === '3' && item.is_cancel === '0'">
                    <button
                      class="btn btn-link btn-color-muted btn-active-color-danger m-0 p-0"
                      @click="role === 'STAFF' ? '' : handleApprove(item)"
                      style="color: red; cursor: pointer"
                    >
                      <i class="bi bi-x-circle"></i>
                    </button>
                  </div>
                </div>
              </td>

              <td
                v-if="
                  item.status === '3' &&
                  item.delete_able === true &&
                  role === 'SYSTEM ADMIN' &&
                  (item.is_cancel === '1' || item.is_cancel === '2')
                "
              >
                <div class="col-sm-6">
                  <button
                    type="button"
                    class="btn btn-link btn-color-muted btn-active-color-danger p-0"
                    @click="goToDelete(item, index)"
                  >
                    <i class="bi bi-trash3-fill"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <DialogConfirmByPass
      :dialogConfirmByPass="dialogConfirmByPass"
      :loadingUpdate="loadingUpdate"
      :typeDoc="typeDoc"
      @submitConfirmPass="submitConfirmPass"
      @closeDialogConformByPass="closeDialogConformByPass"
    />

    <div v-if="isExport">
      <pdfFile
        :dataExport="dataExport"
        @generatedFile="generatedFile"
        :type="1"
      />
    </div>

    <div class="card-footer">
      <Pagination
        :items="tableItems"
        @filterItems="filterItems"
        @handleChangePage="handleChangePage"
      />
    </div>
  </div>
</template>

<script>
import writeXlsxFile from "write-excel-file";
import Swal from "sweetalert2/dist/sweetalert2.js";
import purchaseApi from "@/api/purchase/";
import whApi from "@/api/warehouse/";
import userApi from "@/api/user/";

import DialogConfirmByPass from "./components/dialogConfirmByPass.vue";
import Pagination from "../../components/pagination.vue";
import Loader from "../../components/loaderIndex.vue";
import moment from "moment";

import pdfFile from "../../components/files/purchaseFile.vue";

import { Decode, Encode } from "@/services";

import pdf9 from "../../sale/SA5/pdf/pdf9";
import customerList from "../../sale/SA5/data/customer";

import numbro from "numbro";

export default {
  components: {
    DialogConfirmByPass,
    Pagination,
    Loader,
    pdfFile,
  },
  setup() {
    document.title = "BELUCA | อนุมัติรับสินค้าเข้าคลัง";
  },
  data: () => ({
    loading: false,
    loadingUpdate: false,
    dataItemsShow: [],
    showing1: null,

    arrCheckId: [],

    isEditItem: false,

    dialogConfirmByPass: false,
    typeDoc: "",

    isExport: false,
    loadingExport: false,
    indexExport: "",

    tableItems: [],
    itemApprove: {},

    searchInput: "",
    allData: [],

    dataExport: {
      id: 1,
      name: 2,
    },

    role: "",
    companyBranchInfo: null,
  }),

  async created() {
    this.role = Decode.decode(localStorage.getItem("role")).replace(
      /^"(.*)"$/,
      "$1"
    );
    await this.getCompanyBranchInfo();
    await this.getAll();
  },

  methods: {
    async getCompanyBranchInfo() {
      try {
        const companyBranchId = localStorage.getItem("companyBranchId");
        if (companyBranchId) {
          const response = await userApi.companyBranch.getOne(companyBranchId);
          if (response.response_status === "SUCCESS") {
            this.companyBranchInfo = response.data;
          }
        }
      } catch (error) {
        console.error("Error fetching company branch info:", error);
      }
    },
    setDateThLocale(dateVal) {
      moment.locale("th");
      return moment(dateVal).format("DD/MM/YYYY - HH:mm:ss น.");
    },
    print9() {
      pdf9({ name: "test", desc: "test" });
    },
    async exportExcel() {
      // สร้างข้อมูลสำหรับ Excel โดยเพิ่มส่วนหัว
      const excelData = [
        // แถวที่ 1: แบบ ขย.๙ (ขวาสุด)
        [
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "แบบ ขย.๙",
            fontWeight: "bold",
            fontSize: 14,
            align: "right",
          },
        ],
        // แถวที่ 2: บัญชีการซื้อยา (ตรงกลาง)
        [
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "บัญชีการซื้อยา",
            fontWeight: "bold",
            fontSize: 18,
            align: "center",
            // textDecoration: "underline",
            span: 2,
          },
          null, // เซลล์ที่ถูก merge
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
        ],
        // แถวที่ 3: BearDrug สาขา.....
        [
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: this.companyBranchInfo
              ? `BearDrug ${this.companyBranchInfo.company_branch_name}`
              : "BearDrug สาขา.....",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
            textDecoration: "underline",
            span: 2,
          },
          null, // เซลล์ที่ถูก merge
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
        ],
        // แถวที่ 4: ชื่อสถานที่ขายยา
        [
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: this.companyBranchInfo
              ? `${this.companyBranchInfo.company_branch_code} ${this.companyBranchInfo.company_branch_name} ${this.companyBranchInfo.company_branch_address}`
              : "ชื่อสถานที่ขายยา",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
            // textDecoration: "underline",
            span: 2,
          },
          null, // เซลล์ที่ถูก merge
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
        ],
        // แถวที่ 5: SO No. และเลข SO
        [
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "SO No.",
            fontWeight: "bold",
            fontSize: 14,
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
        ],
        // แถวว่าง
        [
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
          {
            value: "",
            fontWeight: "bold",
          },
        ],
        // หัวตาราง
        [
          {
            value: "ลำดับที่",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "วัน เดือน ปี ที่ซื้อ",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "ชื่อผู้ขาย",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "ชื่อยา",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "เลขที่หรืออักษรของทั้งที่ ผลิต",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "จำนวน/ปริมาณ",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "ลายมือชื่อ ผู้มีหน้าที่ ปฏิบัติการ",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "หมายเหตุ",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
        ],
      ];

      // เพิ่มข้อมูลสินค้า
      let rowIndex = 0;
      const dataRows = this.dataItemsShow.flatMap((item) =>
        item.purchaseOrderItems.map((product) => {
          return [
            {
              value: ++rowIndex,
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: this.formatDate(
                item.receive_date
                  ? item.receive_date.substring(0, 10)
                  : item.createdAt.substring(0, 10)
              ),
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: item.vendor_name || "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.product
                ? `${product.product.product_name} (${
                    product.product.unit ? product.product.unit.unit_name : ""
                  })`
                : "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.lot_number || "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: `${product.item_amt_recieve || product.item_amt} ${
                product.product && product.product.unit
                  ? product.product.unit.unit_name
                  : ""
              }`,
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
          ];
        })
      );

      // รวมข้อมูลทั้งหมด
      const allData = [...excelData, ...dataRows];

      await writeXlsxFile(allData, {
        fileName: "บัญชีการซื้อ.xlsx",
        columns: [
          { width: 8 },
          { width: 15 },
          { width: 20 },
          { width: 40 },
          { width: 20 },
          { width: 15 },
          { width: 25 },
          { width: 15 },
        ],
      });
    },
    async getAll(method) {
      this.loading = true;
      let responseData = [];
      const companyId = localStorage.getItem("companyId");
      const companyBranchId = localStorage.getItem("companyBranchId");

      const objQuery = {
        status: "3",
        companyId: companyId,
        companyBranchId: companyBranchId,
      };

      try {
        responseData = await purchaseApi.purchaseOrder.getAllByStatus(objQuery);
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.dataItemsShow = responseData.data;
        this.tableItems = responseData.data;
        this.allData = responseData.data;
        this.loading = false;
        if (method === 1) {
          await this.$router.push({
            query: {
              page: this.$route.query.page,
              get: 1,
            },
          });
        }
        this.checkEditItem(this.dataItemsShow);
      }
    },

    checkEditItem(item) {
      if (item) {
        item.forEach((element) => {
          element.purchaseOrderItems.forEach((element2) => {
            if (element2.item_amt !== element2.item_amt_recieve) {
              this.arrCheckId.push(element.id);
            }
          });
        });
        this.arrCheckId = this.arrCheckId.filter(function (
          value,
          index,
          array
        ) {
          return array.indexOf(value) === index;
        });
      }
    },

    // find product amt !== receive
    receiveItemNotComplete(items) {
      console.log(items);
      items.forEach((element, index) => {
        console.log({ element });
        element.purchaseOrderItems.forEach((element2) => {
          console.log({ element2 });
        });
      });
    },

    //--- Pagination --- start
    filterItems(val) {
      this.dataItemsShow = val;
    },

    handleChangePage(val, showing1) {
      this.dataItemsShow = val;
      this.showing1 = showing1;
    },
    //--- Pagination --- end
    goToNew() {
      this.$router.push("/warehouse/WH4/new");
    },
    goToEdit(id) {
      this.$router.push({
        path: "/purchase/PU2-3/productIntoWarehouse",
        query: {
          id: id,
          method: "edit",
        },
      });
    },
    gotoImportExcel() {
      this.$router.push("/warehouse/WH4/importexcel");
    },
    goToDelete(item, index) {
      Swal.fire({
        icon: "question",
        title: `ต้องการลบ ${item.receive_no} หรือไม่ ?`,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.confirmDelete(item, index);
        }
      });
    },
    async confirmDelete(item, index) {
      let deleteResponse = [];
      deleteResponse = await purchaseApi.purchaseOrder.delete(item.id);
      if (deleteResponse.response_status === "SUCCESS") {
        Swal.fire({
          icon: "success",
          title: "ลบสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          this.dataItemsShow.splice(index, 1);
          this.tableItems.splice(index, 1);
          this.getAll(1);
        });
      }
    },

    async statusApprove(isApprove, type) {
      let updateResponse = [];
      const id = this.itemApprove.id;

      this.itemApprove = {
        ...this.itemApprove,
        // status: isApprove ? 1 : 3,
        // receive_date: "",
        is_cancel: !isApprove ? "0" : type === "1" ? "2" : "1",
      };

      updateResponse = await purchaseApi.purchaseOrder.update(
        id,
        this.itemApprove
      );
      if (updateResponse.response_status === "SUCCESS") {
        if (isApprove) {
          type === "1"
            ? Swal.fire({
                icon: "success",
                title: `Complete !`,
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {})
            : Swal.fire({
                icon: "error",
                title: `ยกเลิกรับสินค้าเข้าคลัง !`,
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.updateProduct(isApprove);
              });
        }
        this.loadingUpdate = false;
        this.getAll(1);
      } else {
        Swal.fire({
          icon: "warning",
          title: "ยกเลิกรับสินค้าไม่สำเร็จ !",
          Text: "เกิดข้อผิดพลาด !",
          showConfirmButton: false,
          timer: 1500,
        });
        this.loadingUpdate = false;
      }
    },

    // update item
    async updateProduct(isApprove) {
      if (isApprove) {
        console.log(2);
        const updateResponse = await whApi.product.multiUpdatePo(
          this.itemApprove.purchaseOrderItems,
          "purchaseCW"
        );

        if (updateResponse.response_status === "ERROR") {
          Swal.fire({
            icon: "error",
            html: `ปรับสต๊อกสินค้าไม่สำเร็จ !`,
            timer: 4000,
          });
        }
        // else {
        //   this.$router.push({
        //     path: "/purchase/PU2-4",
        //     query: {},
        //   });
        // }
        // this.itemApprove = {
        //   ...this.itemApprove,
        //   // status: isApprove ? 1 : 2,
        // };
        // for (const element of this.itemApprove.purchaseOrderItems) {
        //   await this.getOneProduct(
        //     element.product.id,
        //     element.item_amt_recieve,
        //     element
        //   );
        // }
      }
    },

    async getOneProduct(id, inTransit, item) {
      // console.log({ inTransit });
      let getOneResponse = {};
      try {
        getOneResponse = await whApi.product.getOne(id);
      } catch (error) {
        console.log(error);
      }
      if (getOneResponse.response_status === "SUCCESS") {
        // this.updateProductInTransit(inTransit, getOneResponse.data);
        this.updateProductInTransit(inTransit, getOneResponse.data, id);
        this.updateItemsReceive(item);
      }
    },
    async updateItemsReceive(item) {
      const data = {
        ...item,
        item_amt_new_recieve: 0,
        item_amt_old_recieve: 0,
        item_amt_recieve: item.item_amt,
      };

      const updateItemResponse = await purchaseApi.purchaseOrder.updateItem(
        item.id,
        data
      );

      if (updateItemResponse.response_status !== "SUCCESS") {
        Swal.fire({
          icon: "error",
          html: `สินค้ารหัส : ${item.product_code} จำนวน: ${inTransit} เพิ่มเข้า IN TRANSIT ไม่สำเร็จ !`,
          timer: 4000,
        });
      }
    },
    async updateProductInTransit(inTransit, item, id) {
      let updateResponse = [];

      const body = {
        // ...item,
        id: id,
        product_bring_qty:
          parseInt(item.product_bring_qty) - parseInt(inTransit),
        // product_in_transit:
        //   parseInt(item.product_in_transit) + parseInt(inTransit),
        product_in_transit: 0,
        isUpdateQty: true,
      };

      updateResponse = await whApi.product.update(item.id, body);
      if (updateResponse.response_status !== "SUCCESS") {
        Swal.fire({
          icon: "error",
          html: `สินค้ารหัส : ${item.product_code} จำนวน: ${inTransit} เพิ่มเข้า IN TRANSIT ไม่สำเร็จ !`,
          timer: 4000,
        });
      }
    },
    // update item

    // cancel and lock
    handleApprove(item, type) {
      if (type === "1") {
        this.typeDoc = type;
        this.itemApprove = { ...item };
        this.dialogConfirmByPass = true;
      } else {
        this.itemApprove = { ...item };
        this.dialogConfirmByPass = true;
      }
    },
    async submitConfirmPass(isApprove, type) {
      this.statusApprove(isApprove, type);
      this.dialogConfirmByPass = false;
      this.typeDoc = "";
    },
    closeDialogConformByPass() {
      this.dialogConfirmByPass = false;
      this.typeDoc = "";
    },
    // cancel and lock

    formatDate(date) {
      if (date) {
        const oldDate = moment(date).format("DD/MM/YYYY");

        return oldDate;
      } else {
        return "-";
      }
    },

    // async search() {
    //   this.loading = true;

    //   const status = ["3"];

    //   const responseSearch = await purchaseApi.purchaseOrder.search(
    //     {
    //       search: this.searchInput,
    //     },
    //     status
    //   );

    //   if (responseSearch.response_status === "SUCCESS") {
    //     this.dataItemsShow = responseSearch.data;
    //     this.tableItems = responseSearch.data;
    //     this.allData = responseSearch.data;
    //     this.loading = false;
    //   }
    // },

    // Export file
    goToExport(item, index) {
      this.dataExport = item;
      this.indexExport = index;
      this.loadingExport = true;
      this.isExport = true;
    },
    generatedFile() {
      this.isExport = false;
    },
    hoverExportBtn() {
      this.loadingExport = false;
      this.isExport = false;
    },

    async search() {
      this.loading = true;
      let responseSearch = [];
      const companyId = localStorage.getItem("companyId");
      const companyBranchId = localStorage.getItem("companyBranchId");

      const objQuery = {
        status: "3",
        companyId: companyId,
        companyBranchId: companyBranchId,
      };

      this.searchInput
        ? (responseSearch = await purchaseApi.purchaseOrder.search(
            {
              search: this.searchInput,
            },
            objQuery
          ))
        : this.getAll();

      if (responseSearch.response_status === "SUCCESS") {
        this.dataItemsShow = responseSearch.data;
        this.tableItems = responseSearch.data;
        this.allData = responseSearch.data;
        this.loading = false;
      }
    },

    // Export Excel ในรูปแบบใหม่ตามตัวอย่าง (ทั้งหมด)
    async goToExportExcel() {
      // สร้างข้อมูลสำหรับ Excel ตามรูปแบบที่ต้องการ
      const excelData = [
        // แถวที่ 1: ข้อมูลบริษัท
        [
          {
            value: "บ.บี.เอ็น.ซี แพลนเน็ต ซัพพลาย",
            fontWeight: "bold",
            fontSize: 14,
            align: "left",
          },
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        // แถวที่ 2: ข้อมูลสาขาและที่อยู่
        [
          {
            value: "สาขา สำนักงานใหญ่ เลขประจำตัวผู้เสียภาษี 0205565010118",
            fontSize: 12,
            align: "left",
          },
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        // แถวที่ 3: ที่อยู่
        [
          {
            value:
              "271/16 หมู่ 5 ซ.พรประภานิมิต 6 ต หนองปรือ อ บางละมุง จ ชลบุรี 20150",
            fontSize: 12,
            align: "left",
          },
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        // แถวว่าง
        [null, null, null, null, null, null, null],
        // แถวที่ 5: BearDrug สาขา
        [
          {
            value: this.companyBranchInfo
              ? `BearDrug ${this.companyBranchInfo.company_branch_name}`
              : "BearDrug สาขา แยกตามสาขาที่ตามการล็อคอินเข้าระบบ",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
            borderStyle: "thin",
            borderColor: "#000000",
            span: 7,
          },
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        // แถวว่าง
        [null, null, null, null, null, null, null],
        // แถวที่ 7: ข้อมูลเอกสาร
        [
          {
            value: "เลขเอกสารใบรับเข้า",
            fontWeight: "bold",
            fontSize: 12,
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "วันที่",
            fontWeight: "bold",
            fontSize: 12,
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "เวลา",
            fontWeight: "bold",
            fontSize: 12,
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "พนักงานที่ทำการรับเข้า",
            fontWeight: "bold",
            fontSize: 12,
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "พนักงานที่ทำการอนุมัติ",
            fontWeight: "bold",
            fontSize: 12,
            borderStyle: "thin",
            borderColor: "#000000",
            span: 3,
          },
          null,
          null,
        ],
        // แถวว่าง
        [null, null, null, null, null, null, null],
        // แถวที่ 9: หัวตารางสินค้า
        [
          {
            value: "รายการสินค้าที่รับเข้า",
            fontWeight: "bold",
            fontSize: 14,
            align: "left",
            borderStyle: "thin",
            borderColor: "#000000",
            span: 7,
          },
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        // แถวที่ 10: หัวคอลัมน์ตาราง
        [
          {
            value: "ลำดับ",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "บาร์โค้ด",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "ชื่อสินค้า",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "จำนวน",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "หน่วยสินค้า",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "ราคาต่อหน่วย",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: "ราคารวมทั้งหมด",
            fontWeight: "bold",
            fontSize: 12,
            align: "center",
            backgroundColor: "#f0f0f0",
            borderStyle: "thin",
            borderColor: "#000000",
          },
        ],
      ];

      // เพิ่มข้อมูลสินค้า (ทั้งหมด)
      let rowIndex = 0;
      const dataRows = this.dataItemsShow.flatMap((item) =>
        item.purchaseOrderItems.map((product) => {
          const totalPrice =
            (product.item_amt_recieve || product.item_amt) *
            (product.product ? product.product.product_cost_price : 0);
          return [
            {
              value: ++rowIndex,
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.product ? product.product.product_code : "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.product ? product.product.product_name : "",
              fontSize: 12,
              align: "left",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.item_amt_recieve || product.item_amt,
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value:
                product.product && product.product.unit
                  ? product.product.unit.unit_name
                  : "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: this.formatPrice(
                product.product ? product.product.product_cost_price : 0
              ),
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: this.formatPrice(totalPrice),
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
          ];
        })
      );

      // คำนวณราคารวม (ทั้งหมด)
      const subtotal = this.dataItemsShow.reduce(
        (sum, item) => sum + (item.final_price || 0),
        0
      );
      const vat = subtotal * 0.07; // VAT 7%
      const total = subtotal + vat;

      // เพิ่มแถวสรุปราคา
      const summaryRows = [
        // แถวว่าง
        [null, null, null, null, null, null, null],
        // ราคาสินค้ารวมก่อนภาษี
        [
          null,
          null,
          null,
          null,
          null,
          {
            value: "ราคาสินค้ารวมก่อนภาษี",
            fontWeight: "bold",
            fontSize: 12,
            align: "right",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: this.formatPrice(subtotal),
            fontSize: 12,
            align: "right",
            borderStyle: "thin",
            borderColor: "#000000",
          },
        ],
        // ภาษีมูลค่าเพิ่ม
        [
          null,
          null,
          null,
          null,
          null,
          {
            value: "ภาษีมูลค่าเพิ่ม",
            fontWeight: "bold",
            fontSize: 12,
            align: "right",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: this.formatPrice(vat),
            fontSize: 12,
            align: "right",
            borderStyle: "thin",
            borderColor: "#000000",
          },
        ],
        // ราคาสินค้าทั้งหมด
        [
          null,
          null,
          null,
          null,
          null,
          {
            value: "ราคาสินค้าทั้งหมด",
            fontWeight: "bold",
            fontSize: 12,
            align: "right",
            borderStyle: "thin",
            borderColor: "#000000",
          },
          {
            value: this.formatPrice(total),
            fontWeight: "bold",
            fontSize: 12,
            align: "right",
            borderStyle: "thin",
            borderColor: "#000000",
          },
        ],
        // แถวว่าง
        [null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null],
        // แถวลายเซ็น
        [
          {
            value: "______________",
            fontSize: 12,
            align: "center",
          },
          null,
          {
            value: "______________",
            fontSize: 12,
            align: "center",
          },
          null,
          {
            value: "______________",
            fontSize: 12,
            align: "center",
          },
          null,
          {
            value: "______________",
            fontSize: 12,
            align: "center",
          },
        ],
        // แถวข้อความใต้ลายเซ็น
        [
          {
            value: "ผู้รับสินค้า",
            fontSize: 12,
            align: "center",
          },
          null,
          {
            value: "วันที่",
            fontSize: 12,
            align: "center",
          },
          null,
          {
            value: "ผู้อนุมัติ",
            fontSize: 12,
            align: "center",
          },
          null,
          {
            value: "วันที่",
            fontSize: 12,
            align: "center",
          },
        ],
      ];

      // รวมข้อมูลทั้งหมด
      const allData = [...excelData, ...dataRows, ...summaryRows];

      await writeXlsxFile(allData, {
        fileName: `ใบรับสินค้าทั้งหมด_${
          new Date().toISOString().split("T")[0]
        }.xlsx`,
        columns: [
          { width: 8 }, // ลำดับ
          { width: 15 }, // บาร์โค้ด
          { width: 30 }, // ชื่อสินค้า
          { width: 10 }, // จำนวน
          { width: 12 }, // หน่วย
          { width: 15 }, // ราคาต่อหน่วย
          { width: 15 }, // ราคารวม
        ],
        // write-excel-file ไม่รองรับ sheet configuration
        // การตั้งค่าขนาดกระดาษจะต้องทำใน Excel โดยตรง
      });
    },

    // Export Excel แบบรายแถว - พิมพ์ใบ ขย. 9
    async exportSingleExcel(item, index) {
      try {
        // สร้างข้อมูลสำหรับ Excel โดยเพิ่มส่วนหัว (เหมือน exportExcel)
        const excelData = [
          // แถวที่ 1: แบบ ขย.๙ (ขวาสุด)
          [
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "แบบ ขย.๙",
              fontWeight: "bold",
              fontSize: 14,
              align: "right",
            },
          ],
          // แถวที่ 2: บัญชีการซื้อยา (ตรงกลาง)
          [
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "บัญชีการซื้อยา",
              fontWeight: "bold",
              fontSize: 18,
              align: "center",
              span: 2,
            },
            null, // เซลล์ที่ถูก merge
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
          ],
          // แถวที่ 3: BearDrug สาขา.....
          [
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: this.companyBranchInfo
                ? `BearDrug ${this.companyBranchInfo.company_branch_name}`
                : "BearDrug สาขา.....",
              fontWeight: "bold",
              fontSize: 14,
              align: "center",
              textDecoration: "underline",
              span: 2,
            },
            null, // เซลล์ที่ถูก merge
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
          ],
          // แถวที่ 4: ชื่อสถานที่ขายยา
          [
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: this.companyBranchInfo
                ? `${this.companyBranchInfo.company_branch_code} ${this.companyBranchInfo.company_branch_name} ${this.companyBranchInfo.company_branch_address}`
                : "ชื่อสถานที่ขายยา",
              fontWeight: "bold",
              fontSize: 14,
              align: "center",
              span: 2,
            },
            null, // เซลล์ที่ถูก merge
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
          ],
          // แถวที่ 5: SO No. และเลข SO
          [
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "SO No.",
              fontWeight: "bold",
              fontSize: 14,
            },
            {
              value: item.receive_no || "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
          ],
          // แถวว่าง
          [
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
            {
              value: "",
              fontWeight: "bold",
            },
          ],
          // แถวหัวตาราง
          [
            {
              value: "ลำดับ",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "วัน เดือน ปี ที่ซื้อ",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "ชื่อผู้ขาย",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "ชื่อยา",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "เลขที่หรืออักษรของทั้งที่ ผลิต",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "จำนวน/ปริมาณ",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "ลายมือชื่อ ผู้มีหน้าที่ ปฏิบัติการ",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "หมายเหตุ",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
          ],
        ];

        // เพิ่มข้อมูลสินค้า (เฉพาะรายการนี้)
        let rowIndex = 0;
        const dataRows = item.purchaseOrderItems.map((product) => {
          return [
            {
              value: ++rowIndex,
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: this.formatDate(
                item.receive_date
                  ? item.receive_date.substring(0, 10)
                  : item.createdAt.substring(0, 10)
              ),
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: item.vendor_name || "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.product
                ? `${product.product.product_name} (${
                    product.product.unit ? product.product.unit.unit_name : ""
                  })`
                : "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.lot_number || "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.item_amt_recieve || product.item_amt || "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
          ];
        });

        // รวมข้อมูลทั้งหมด
        const allData = [...excelData, ...dataRows];

        await writeXlsxFile(allData, {
          fileName: `ขย9_${item.receive_no || "รายการ"}_${
            new Date().toISOString().split("T")[0]
          }.xlsx`,
          columns: [
            { width: 8 },
            { width: 15 },
            { width: 20 },
            { width: 40 },
            { width: 20 },
            { width: 15 },
            { width: 25 },
            { width: 15 },
          ],
        });
      } catch (error) {
        console.error("Export Excel Error:", error);
        Swal.fire({
          icon: "error",
          title: "Export ไม่สำเร็จ",
          text: "เกิดข้อผิดพลาดในการ Export Excel",
        });
      }
    },

    // Export Excel แบบรายแถว - ใบรับสินค้า
    async exportReceiveExcel(item, index) {
      try {
        // สร้างข้อมูลสำหรับ Excel ตามรูปแบบใบรับสินค้า (เหมือน goToExportExcel)
        const excelData = [
          // แถวที่ 1: ข้อมูลบริษัท
          [
            {
              value: "บ.บี.เอ็น.ซี แพลนเน็ต ซัพพลาย",
              fontWeight: "bold",
              fontSize: 14,
              align: "center",
              span: 7,
            },
            null,
            null,
            null,
            null,
            null,
            null,
          ],
          // แถวที่ 2: ข้อมูลสาขาและที่อยู่
          [
            {
              value: "สาขา สำนักงานใหญ่ เลขประจำตัวผู้เสียภาษี 0205565010118",
              fontSize: 12,
              align: "center",
              span: 7,
            },
            null,
            null,
            null,
            null,
            null,
            null,
          ],
          // แถวที่ 3: ที่อยู่
          [
            {
              value:
                "271/16 หมู่ 5 ซ.พรประภานิมิต 6 ต หนองปรือ อ บางละมุง จ ชลบุรี 20150",
              fontSize: 12,
              align: "center",
              span: 7,
            },
            null,
            null,
            null,
            null,
            null,
            null,
          ],
          // แถวว่าง
          [null, null, null, null, null, null, null],
          // แถวที่ 5: BearDrug สาขา
          [
            {
              value: this.companyBranchInfo
                ? `BearDrug ${this.companyBranchInfo.company_branch_name}`
                : "BearDrug สาขา แยกตามสาขาที่ตามการล็อคอินเข้าระบบ",
              fontWeight: "bold",
              fontSize: 14,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
              span: 7,
            },
            null,
            null,
            null,
            null,
            null,
            null,
          ],
          // แถวว่าง
          [null, null, null, null, null, null, null],
          // แถวที่ 7: ข้อมูลเอกสาร
          [
            {
              value: "เลขเอกสารใบรับเข้า",
              fontWeight: "bold",
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "วันที่",
              fontWeight: "bold",
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "เวลา",
              fontWeight: "bold",
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "พนักงานที่ทำการรับเข้า",
              fontWeight: "bold",
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "พนักงานที่ทำการอนุมัติ",
              fontWeight: "bold",
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
              span: 3,
            },
            null,
            null,
          ],
          // แถวข้อมูลเอกสาร
          [
            {
              value: item.receive_no || "-",
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: item.receive_date
                ? this.formatDate(item.receive_date.substring(0, 10))
                : this.formatDate(item.createdAt.substring(0, 10)),
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: item.receive_date
                ? item.receive_date.substring(11, 19)
                : item.createdAt.substring(11, 19),
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: item.created_by_name || "-",
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: item.approved_by_name || "-",
              fontSize: 12,
              borderStyle: "thin",
              borderColor: "#000000",
              span: 3,
            },
            null,
            null,
          ],
          // แถวว่าง
          [null, null, null, null, null, null, null],
          // แถวหัวข้อตาราง: รายการสินค้าที่รับเข้า
          [
            {
              value: "รายการสินค้าที่รับเข้า",
              fontWeight: "bold",
              fontSize: 14,
              align: "left",
              borderStyle: "thin",
              borderColor: "#000000",
              span: 7,
            },
            null,
            null,
            null,
            null,
            null,
            null,
          ],
          // แถวหัวตาราง
          [
            {
              value: "ลำดับ",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "บาร์โค้ด",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "ชื่อสินค้า",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "จำนวน",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "หน่วยสินค้า",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "ราคาต่อหน่วย",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: "ราคารวมทั้งหมด",
              fontWeight: "bold",
              fontSize: 12,
              align: "center",
              backgroundColor: "#f0f0f0",
              borderStyle: "thin",
              borderColor: "#000000",
            },
          ],
        ];

        // เพิ่มข้อมูลสินค้า (เฉพาะรายการนี้)
        let rowIndex = 0;
        const dataRows = item.purchaseOrderItems.map((product) => {
          const totalPrice =
            (product.item_amt_recieve || product.item_amt) *
            (product.product ? product.product.product_cost_price : 0);
          return [
            {
              value: ++rowIndex,
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.product ? product.product.product_barcode : "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.product ? product.product.product_name : "",
              fontSize: 12,
              align: "left",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: product.item_amt_recieve || product.item_amt || "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value:
                product.product && product.product.unit
                  ? product.product.unit.unit_name
                  : "",
              fontSize: 12,
              align: "center",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: this.formatPrice(
                product.product ? product.product.product_cost_price : 0
              ),
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: this.formatPrice(totalPrice),
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
          ];
        });

        // คำนวณราคารวม (เฉพาะรายการนี้)
        const subtotal = item.final_price || 0;
        const vat = subtotal * 0.07; // VAT 7%
        const total = subtotal + vat;

        // เพิ่มแถวสรุปราคา
        const summaryRows = [
          // แถวว่าง
          [null, null, null, null, null, null, null],
          // ราคาสินค้ารวมก่อนภาษี
          [
            null,
            null,
            null,
            null,
            null,
            {
              value: "ราคาสินค้ารวมก่อนภาษี",
              fontWeight: "bold",
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: this.formatPrice(subtotal),
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
          ],
          // ภาษีมูลค่าเพิ่ม
          [
            null,
            null,
            null,
            null,
            null,
            {
              value: "ภาษีมูลค่าเพิ่ม",
              fontWeight: "bold",
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: this.formatPrice(vat),
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
          ],
          // ราคาสินค้าทั้งหมด
          [
            null,
            null,
            null,
            null,
            null,
            {
              value: "ราคาสินค้าทั้งหมด",
              fontWeight: "bold",
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
            {
              value: this.formatPrice(total),
              fontWeight: "bold",
              fontSize: 12,
              align: "right",
              borderStyle: "thin",
              borderColor: "#000000",
            },
          ],
          // แถวว่าง
          [null, null, null, null, null, null, null],
          [null, null, null, null, null, null, null],
          // แถวลายเซ็น
          [
            {
              value: "______________",
              fontSize: 12,
              align: "center",
            },
            null,
            {
              value: "______________",
              fontSize: 12,
              align: "center",
            },
            null,
            {
              value: "______________",
              fontSize: 12,
              align: "center",
            },
            null,
            {
              value: "______________",
              fontSize: 12,
              align: "center",
            },
          ],
          // แถวข้อความใต้ลายเซ็น
          [
            {
              value: "ผู้รับสินค้า",
              fontSize: 12,
              align: "center",
            },
            null,
            {
              value: "วันที่",
              fontSize: 12,
              align: "center",
            },
            null,
            {
              value: "ผู้อนุมัติ",
              fontSize: 12,
              align: "center",
            },
            null,
            {
              value: "วันที่",
              fontSize: 12,
              align: "center",
            },
          ],
        ];

        // รวมข้อมูลทั้งหมด
        const allData = [...excelData, ...dataRows, ...summaryRows];

        await writeXlsxFile(allData, {
          fileName: `ใบรับสินค้า_${item.receive_no || "รายการ"}_${
            new Date().toISOString().split("T")[0]
          }.xlsx`,
          columns: [
            { width: 8 },
            { width: 15 },
            { width: 30 },
            { width: 10 },
            { width: 12 },
            { width: 15 },
            { width: 15 },
          ],
        });
      } catch (error) {
        console.error("Export Receive Excel Error:", error);
        Swal.fire({
          icon: "error",
          title: "Export ไม่สำเร็จ",
          text: "เกิดข้อผิดพลาดในการ Export ใบรับสินค้า Excel",
        });
      }
    },

    formatPrice(val) {
      if (val) {
        const newVal = numbro(val).format({
          thousandSeparated: true,
          mantissa: 2,
        });
        return newVal;
      } else {
        const newVal = numbro(0).format({
          thousandSeparated: true,
          mantissa: 2,
        });
        return newVal;
      }
    },
  },
};
</script>
